export default function imageExtensionIsSafe(type: string) {
    const extensionParts = String(type || '').split('.')

    if (extensionParts.length < 1) {
        return false;
    }

    const extension = extensionParts.pop();

    switch ((extension || '').toLowerCase()) {
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'gif':
            return true;
        default:
            return false;
    }
}
